
export default {
  layout: 'fullwidth',

  head() {
    return {
      title: `Prix immobiliers à ${this.city.full_name} (${this.city.region.fr_code_dep}), historique des ventes - ${this.$config.siteTitle}`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `Consultez l'historique des ventes immobilières à ${this.city.full_name}. Recherchez les dernières transactions. Sources : fichier DVF,  actes notariés et informations cadastrales.`,
        },
      ],
    };
  },

  async asyncData({ params, $axios, $config: { baseApiURL }, error }) {
    const props = await $axios
      .$get(`${baseApiURL}/cities/${params.slug}`)
      .catch(() => error({ statusCode: 404, message: 'City not found' }));

    return {
      city: props.city,
    };
  },

  methods: {
    selectCity(hit) {
      this.$router.push(`/prix-immobilier/${hit.slug}/`);
    },
  },
};
